import ContainerConfig from './ContainerConfig';

export const EDIT = "Edit";
export const CUSTOM_LAYOUT = "CustomLayout";

/**
 * @author chen yu
 * @date 07/01/2021 01:01:28
 * @class
 * @extends {ContainerConfig}
 */
class LayoutConfig extends ContainerConfig {

    /**
     * @constructs
     * @param {object} options 
     */
    constructor(options) {

        super({
            parent: null,
            PositionInfo: options.PositionInfo || {
                Column: 1,
                Columns: options?.VueEditLayout?.ColumnNumber || 24,
                Row: 1,
                Rows: 0
            },
            ...options || {}
        });

        /**
         * @type {Array.<ColInfo>}
         * @description 当前布局中使用的列信息
         */
        this.ColInfoList = Array.isArray(options.ColInfoList) ? options.ColInfoList : [];

        /**
         * @type {number}
         * @description 一行的格子数量
         */
        this._ColumnNumber = options?.VueEditLayout?.ColumnNumber || 24;

        /**
         * @type {boolean}
         * @description 是否开启自定义布局模式
         */
        this._Mode = EDIT;

        /**
         * @type {object}
         * @description 拖拽上下文
         */
        this._DragContext = null;

        /**
         * @type {'DraggingControl' | 'EditData' | 'ReszieControl'}
         * @description 状态
         */
        this._State = "EditData";

    }

    set ColumnNumber(columnNumber) {
        this._ColumnNumber = columnNumber
    }

    get ColumnNumber() {
        return this._ColumnNumber;
    }

    set Mode(mode) {
        this._Mode = mode;
    }

    get Mode() {
        return this._Mode;
    }

    set DragContext(dragContext) {
        this._DragContext = dragContext;
    }

    get DragContext() {
        return this._DragContext;
    }

    get State() {
        return this._State;
    }

    set State(state) {
        this._State = state;
    }

    Each(fn) {

        var _list = [this];

        for (let _i = 0; _i < _list.length; _i++) {

            const _item = _list[_i];

            fn(_item);

            if (_item instanceof ContainerConfig) {
                _list = _list.concat(_item.Children);
            }

        }

    }
};

export default LayoutConfig;